import { Link } from "gatsby"
import React from "react"
import * as style from "./style.module.css"
import json from "/src/siteData.json"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"

const phoneNumber = json.footer.phoneNumber

const Component = () => {
  const data = json.footer

  return (
    <div className={style.container}>
      <div className={style.heading}>CONTACT</div>
      <small>{data.contactButton}</small>
      <div className={style.decoration}></div>
      <p>
        <span>ご不明点がございましたら、</span>
        <span>お気軽にお問い合わせください。</span>
      </p>
      <Link href={`tel:+81${phoneNumber}`}>
        <div className={style.tel}>
            Tel:{phoneNumber}
        </div>
      </Link>

      <Link className={style.button} to={getPathFromTemplateType(6)}>
        お問い合わせフォームはこちら
      </Link>
    </div>
  )
}

export default Component
